import { MODULE as PARENT } from '../constants'

export const KEY = 'orders'
export const MODULE = [...[PARENT], KEY]

export const FETCH_ORDERS = `${MODULE.join('/')}-fetch`
export const CLEAR_ORDERS = `${MODULE.join('/')}-clear`
// export const CREATE_ORDER = `${MODULE.join('/')}-create`
